export default {
  id: 106,
  title: "Target #106 - Ryuk's Apple",
  url: 'https://cssbattle.dev/play/106',
  colors: ['#000000', '#D4392D'],
  solution:
    '<a a><a b><a c><a d><style>[a],[b]{top:90;width:100;height:120;background:#d4392d}[c],body{background:#000}[a],[c]{border-radius:100%;transform:rotate(30deg)}[a],[b],[d]{background:#d4392d}a{position:fixed}[a]{left:180}[b]{left:120;border-radius:100%;transform:rotate(-30deg)}[c]{top:100;left:100;width:50;height:60;box-shadow:20px 35px}[d]{top:70;left:195;width:10;height:50}</style>',
}
